// export enum Adress {
// 	logRegister = "http://192.168.1.102:3001/ftp",
// 	connect = "http://192.168.1.102:3001/ftp",
// 	readList = "http://192.168.1.102:3001/ftp/list",
// 	ListReadOne = "http://192.168.1.102:3001/ftp/listGetOneRead",
// 	getOne = "http://192.168.1.102:3001/ftp/listGetOne",
// 	send = "http://192.168.1.102:3001/ftp/file",
// 	sendBigFile = "http://192.168.1.102:3001/ftp/bigFile",
// 	newFolder = "http://192.168.1.102:3001/ftp/newfolder",
// 	removeFile = "http://192.168.1.102:3001/ftp/removeFile",
// 	renameFile = "http://192.168.1.102:3001/ftp/renameFile",
// 	ftpOptions = "http://192.168.1.102:3001/ftp/ftpOptions",
// 	logOut = "http://192.168.1.102:3001/ftp/logOut",
// 	smallImage = "http://192.168.1.102:3001/ftp/listGetSmallImage",
// 	icon = "http://192.168.1.102:3001/ftp",
// 	singleImage = "http://192.168.1.102:3001/ftp/getSingleImage",
// 	test = "http://192.168.1.102:3001/ftp/getSingleVideo",
// 	frameFromVideo = "http://192.168.1.102:3001/ftp/frameFromVideo",
// }

export enum Adress {
	logRegister = "/ftp",
	connect = "/ftp",
	readList = "/ftp/list",
	ListReadOne = "/ftp/listGetOneRead",
	getOne = "/ftp/listGetOne",
	send = "/ftp/file",
	sendBigFile = "/ftp/bigFile",
	newFolder = "/ftp/newfolder",
	removeFile = "/ftp/removeFile",
	renameFile = "/ftp/renameFile",
	ftpOptions = "/ftp/ftpOptions",
	logOut = "/ftp/logOut",
	smallImage = "/ftp/listGetSmallImage",
	icon = "/ftp",
	singleImage = "/ftp/getSingleImage",
	test = "/ftp/getSingleVideo",
	frameFromVideo = "/ftp/frameFromVideo",
}
